import React, { useState, useRef, useEffect, useMemo } from 'react';
import { AUDIO_TYPE as AUDIO_TYPE$1, mergeStyles } from 'wix-rich-content-common';
import ReactPlayer from 'react-player';
import { LoaderIcon, PlayIcon, PauseIcon, Image, Slider, SLIDER_TRACK_SIZE, SoundMutedIcon, SoundIcon, FocusManager, ContextMenuIcon, DownloadIcon, SLIDER_THUMB_VISIBILITY, PlaybackIcon } from 'wix-rich-content-ui-components';
import { AUDIO_TYPE } from 'ricos-content';
export { AUDIO_TYPE } from 'ricos-content';
import { Node_Type } from 'ricos-types';
import classNames from 'classnames';
import { getImageSrc } from 'wix-rich-content-common/libs/imageUtils';
import { KEYS_CHARCODE, ClickOutside } from 'wix-rich-content-editor-common';
import { debounce } from 'lodash';
import HtmlComponent from 'wix-rich-content-plugin-html/libs/HtmlComponent';

var styles = {"fontElementMap":"U6pbI","customPlayer":"aIYbM","customPlayer_basic":"yWGpc","customPlayer_mobile":"_7yy7w","audio_coverImg":"hu6KX","audio_small_cover_image":"_0MH8n","audio_icon_button":"yEqrj","audio_contextMenu_wrapper":"sTDA-","customPlayer_with_image":"db4In","track_wrapper":"vGYOv","trackContainer":"PWLEJ","audio_download_icon":"LGntK","audio_duration":"FixzP","customPlayer_small_fit":"zAH1F","track_sliders_wrapper":"_5yXSW","audio_volume_wrapper":"zDlt3","volume_slider_wrapper":"-Z3Mj","audioDetails":"_4nUa3","title":"j8Da5","author_name":"TG3k8","dropdown_menu_wrapper":"KUoG-","dropdown_selected_button":"_7mqbr","dropdown_content":"jxLlF","dropdown_content_withIcon":"IMHdF","audio_loader_icon":"_1h-Vi","spin":"QEi83"};

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
const modalContentStyles = {
  width: 363,
  padding: 20,
  boxSizing: "border-box",
  border: "solid 1px rgba(51, 51, 51, 0.1)",
  borderRadius: "var(--ricos-settings-whitebox-border-radius, 2px)",
  boxShadow: "var(--ricos-settings-whitebox-box-shadow, 0 0 10px 0 rgba(0, 0, 0, 0.06))"
};
__spreadValues$3({
  height: 232
}, modalContentStyles);
__spreadValues$3({
  height: 180
}, modalContentStyles);
const downloadFile = (url, fileName) => {
  fetch(url, {
    method: "GET"
  }).then((response) => response.blob()).then((blob) => {
    const url2 = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url2;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  });
};
const getAudioSrc = (src, settings) => {
  if (src == null ? void 0 : src.url)
    return src.url;
  if (typeof src === "object") {
    if (settings && settings.getAudioUrl) {
      return settings.getAudioUrl(src);
    } else {
      console.error("must set getAudioUrl in plugin config when using custom audio source!", src);
    }
  }
  return src;
};
const playbackRates = [
  {
    text: "0.25",
    rate: 0.25
  },
  {
    text: "0.5",
    rate: 0.5
  },
  {
    text: "0.75",
    rate: 0.75
  },
  {
    text: "Normal",
    rate: 1
  },
  {
    text: "1.25",
    rate: 1.25
  },
  {
    text: "1.5",
    rate: 1.5
  },
  {
    text: "1.75",
    rate: 1.75
  },
  {
    text: "2",
    rate: 2
  }
];
const AUDIO_ACTION_NAMES = {
  fileDownloaded: "fileDownloaded",
  playAudio: "playAudio",
  changeTitle: "changeTitle",
  changeCreator: "changeCreator",
  changeCover: "changeCover",
  downloadAudio: "downloadAudio"
};
const AUDIO_BI_VALUES = {
  PLAY: "play",
  PAUSE: "pause",
  PLAYBACK_COMPLETED: "playbackCompleted",
  YES: "yes",
  NO: "no",
  click: "Click"
};
const AUDIO_TYPES = { custom: "File Upload", spotify: "Spotify", soundCloud: "SoundCloud" };
({
  insert: `${Node_Type.AUDIO}.insert`,
  settings: `${Node_Type.AUDIO}.settings`,
  insertAudio: `${Node_Type.AUDIO}.insertAudio`,
  insertSoundCloud: `${Node_Type.AUDIO}.insertSoundCloud`,
  insertSpotify: `${Node_Type.AUDIO}.insertSpotify`,
  replace: `${Node_Type.AUDIO}.replace`
});
({
  size: `${Node_Type.AUDIO}.size`,
  alignment: `${Node_Type.AUDIO}.alignment`
});

const AudioActionIcons = ({
  isPlaying,
  handlePause,
  handlePlay,
  disabled,
  isLoading,
  helpers
}) => {
  const onClick = () => {
    var _a;
    const ACTION_BI_VALUE = isPlaying ? AUDIO_BI_VALUES.PAUSE : AUDIO_BI_VALUES.PLAY;
    (_a = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a.call(helpers, AUDIO_TYPE, AUDIO_ACTION_NAMES.playAudio, ACTION_BI_VALUE);
    isPlaying ? handlePause() : handlePlay();
  };
  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      onClick();
    }
  };
  const ComponentIcon = disabled || !isPlaying ? PlayIcon : PauseIcon;
  const ariaLabel = isPlaying ? "pause" : "play";
  return isLoading ? /* @__PURE__ */ React.createElement(LoaderIcon, { className: styles.audio_loader_icon }) : /* @__PURE__ */ React.createElement(
    "button",
    {
      className: styles.audio_icon_button,
      onClick,
      onKeyPress,
      "aria-label": ariaLabel
    },
    /* @__PURE__ */ React.createElement(ComponentIcon, null)
  );
};

const AudioDetails = ({ authorName, title }) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.audioDetails }, title && /* @__PURE__ */ React.createElement("span", { className: styles.title }, title), authorName && /* @__PURE__ */ React.createElement("span", { className: styles.author_name }, authorName));
};

const Duration = ({ seconds }) => {
  return /* @__PURE__ */ React.createElement("time", { dateTime: `P${Math.round(seconds)}S` }, format(seconds));
};
function format(seconds) {
  const date = new Date(seconds * 1e3);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = pad(date.getUTCSeconds());
  if (hh) {
    return `${hh}:${pad(mm)}:${ss}`;
  }
  return `${mm}:${ss}`;
}
function pad(string) {
  return ("0" + string).slice(-2);
}
const AudioDuration = ({
  elapsed,
  duration,
  isMobile,
  isSmallWidth
}) => {
  const shouldRenderElapsed = !(isMobile || isSmallWidth);
  return /* @__PURE__ */ React.createElement("div", { className: styles.audio_duration }, shouldRenderElapsed && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Duration, { seconds: elapsed }), " /"), /* @__PURE__ */ React.createElement(Duration, { seconds: duration }));
};

const AudioImage = ({ getImageUrl, coverImage, isSmallImage }) => {
  return /* @__PURE__ */ React.createElement(
    Image,
    {
      src: getImageSrc({ file_name: coverImage.src }, getImageUrl, {
        requiredWidth: 84,
        requiredHeight: 84,
        requiredQuality: 70
      }),
      className: classNames(styles.audio_coverImg, {
        [styles.audio_small_cover_image]: isSmallImage
      }),
      resizeMode: "cover",
      theme: styles
    }
  );
};

const SoundControl = ({
  volume,
  muted,
  handleMute,
  theme,
  handleVolumeChange
}) => {
  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      handleMute();
    }
  };
  const onKeyDown = (e) => {
    const shouldDecrease = e.key === "ArrowDown" && volume > 0;
    const shouldIncrease = e.key === "ArrowUp" && volume < 1;
    const newVolume = shouldDecrease ? volume - 0.1 : shouldIncrease ? volume + 0.1 : volume;
    handleVolumeChange(parseFloat(newVolume.toFixed(1)));
  };
  const SoundIconComponent = muted ? SoundMutedIcon : SoundIcon;
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      className: classNames(styles.audio_icon_button, styles.audio_volume_wrapper),
      onKeyPress,
      onKeyDown,
      "aria-label": "sound"
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.volume_slider_wrapper }, /* @__PURE__ */ React.createElement(
      Slider,
      {
        theme,
        min: 0,
        max: 1,
        step: "any",
        value: volume,
        onChange: handleVolumeChange,
        onChangeCommitted: handleVolumeChange,
        languageDir: "ltr",
        dataHook: "audioVolumeSlider",
        trackSize: SLIDER_TRACK_SIZE.small,
        liveSiteWiring: true,
        tabIndex: -1
      }
    )),
    /* @__PURE__ */ React.createElement(SoundIconComponent, { className: styles.audio_sound_icon, onClick: handleMute })
  );
};

const optionElement = (option) => {
  const selected = option == null ? void 0 : option.selected;
  const content = option.icon ? /* @__PURE__ */ React.createElement("span", { className: styles.dropdown_content_withIcon }, option.icon(), option.text) : /* @__PURE__ */ React.createElement("span", { className: styles.dropdown_content }, option.text);
  const onKeyDown = (e) => {
    if (e.keyCode === KEYS_CHARCODE.ENTER) {
      option.onClick();
    }
  };
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      key: option.text,
      className: selected ? styles.dropdown_selected_button : "",
      onKeyDown,
      onClick: option.onClick,
      "data-hook": option == null ? void 0 : option.dataHook
    },
    content
  );
};
const DropdownMenu = ({ options, onClose }) => {
  const onKeyDown = (e) => {
    if (e.keyCode === KEYS_CHARCODE.ESCAPE) {
      onClose();
    }
  };
  return /* @__PURE__ */ React.createElement(FocusManager, { onKeyDown }, /* @__PURE__ */ React.createElement("div", { className: styles.dropdown_menu_wrapper }, options.map((option) => optionElement(option))));
};

const ContextMenu = ({
  onClickOutside,
  contextMenuData,
  playBackMenuData,
  showContextMenu,
  showPlaybackMenu,
  onClick
}) => {
  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      onClick();
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ClickOutside, { onClickOutside }, showContextMenu && /* @__PURE__ */ React.createElement(DropdownMenu, { options: contextMenuData, onClose: onClickOutside }), showPlaybackMenu && /* @__PURE__ */ React.createElement(DropdownMenu, { options: playBackMenuData, onClose: onClickOutside })), /* @__PURE__ */ React.createElement(
    ContextMenuIcon,
    {
      "data-hook": "audioContextMenu",
      tabIndex: 0,
      onKeyPress,
      className: styles.audio_contextMenuIcon,
      onClick,
      "aria-label": "context menu"
    }
  ));
};

const ReactPlayerWrapper = ({
  url,
  authorName,
  name,
  disableDownload,
  coverImage,
  helpers,
  isMobile,
  showControls,
  disabled,
  theme,
  isLoading,
  saveDurationToData,
  isDownloadDisabled
}) => {
  const [URL, setURL] = useState(url);
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [seeking, setSeeking] = useState(false);
  const [played, setPlayed] = useState(0);
  const [volume, setVolume] = useState(1);
  const [lastVolume, setLastVolume] = useState(1);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [showPlaybackMenu, setShowPlaybackMenu] = useState(false);
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [isStoppedBySeek, setIsStoppedBySeek] = useState(false);
  const [currentWidth, setCurrentWidth] = useState(0);
  const resizeWidths = { small: 320 };
  const reactPlayerSize = showControls ? "100%" : 0;
  const hasDetails = authorName || name;
  const reactPlayerRef = useRef(null);
  const customPlayerRef = useRef(null);
  const onDownload = () => downloadFile(URL, name || "untitled");
  const showMobileDownloadIcon = isMobile && hasDetails && !disableDownload && !isDownloadDisabled;
  const playBackMenuData = playbackRates.map(({ text, rate }) => ({
    text,
    onClick: () => {
      setPlaybackRate(rate);
      setShowPlaybackMenu(false);
    },
    selected: playbackRate === rate
  }));
  const contextMenuOptions = {
    download: {
      text: "Download",
      onClick: () => {
        var _a;
        (_a = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a.call(
          helpers,
          AUDIO_TYPE,
          AUDIO_ACTION_NAMES.fileDownloaded,
          AUDIO_BI_VALUES.click
        );
        onDownload();
        setShowContextMenu(false);
      },
      dataHook: "audioDownloadIcon",
      icon: DownloadIcon
    },
    playback: {
      text: "Playback Speed",
      onClick: () => {
        setShowContextMenu(false);
        setShowPlaybackMenu(true);
      },
      dataHook: "audioPlaybackIcon",
      icon: PlaybackIcon
    }
  };
  const contextMenuData = disableDownload ? [contextMenuOptions.playback] : [contextMenuOptions.download, contextMenuOptions.playback];
  const handleProgress = (state) => {
    if (!seeking) {
      setPlayed(state.played);
    }
  };
  const onEnded = () => {
    var _a;
    return (_a = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a.call(
      helpers,
      AUDIO_TYPE,
      AUDIO_ACTION_NAMES.playAudio,
      AUDIO_BI_VALUES.PLAYBACK_COMPLETED
    );
  };
  const handleDuration = (num) => {
    var _a;
    setDuration(num);
    saveDurationToData(num);
    const audioType = showControls ? AUDIO_TYPES.soundCloud : AUDIO_TYPES.custom;
    (_a = helpers == null ? void 0 : helpers.mediaPluginsDetails) == null ? void 0 : _a.call(helpers, {
      pluginId: AUDIO_TYPE,
      creator: authorName,
      title: name,
      track_duration: num == null ? void 0 : num.toString(),
      type: audioType,
      url
    });
  };
  const handleSeekChange = (num) => {
    isPlaying && setIsStoppedBySeek(true);
    handlePause();
    setSeeking(true);
    setPlayed(num);
  };
  const handlePlay = () => setIsPlaying(true);
  const handlePause = () => setIsPlaying(false);
  const handleContextMenuClick = () => {
    showContextMenu || showPlaybackMenu ? onClickOutside() : setShowContextMenu(true);
  };
  const handleSeekMouseUp = (num) => {
    var _a;
    (_a = reactPlayerRef == null ? void 0 : reactPlayerRef.current) == null ? void 0 : _a.seekTo(num);
    setSeeking(false);
    isStoppedBySeek && handlePlay();
    setIsStoppedBySeek(false);
  };
  const handleMute = () => {
    if (volume !== 0) {
      setLastVolume(volume);
      setVolume(0);
    } else {
      setVolume(lastVolume);
    }
  };
  const onClickOutside = () => {
    setShowContextMenu(false);
    setShowPlaybackMenu(false);
  };
  const renderAudioDuration = () => /* @__PURE__ */ React.createElement(
    AudioDuration,
    {
      elapsed: played * duration,
      duration,
      isMobile,
      isSmallWidth: resizeWidths.small >= currentWidth
    }
  );
  useEffect(() => {
    handlePause();
    setURL(url);
  }, [showControls, url]);
  useEffect(() => {
    var _a;
    (_a = reactPlayerRef.current) == null ? void 0 : _a.seekTo(0);
  }, []);
  useEffect(() => {
    var _a;
    let resizer;
    if (window == null ? void 0 : window.ResizeObserver) {
      resizer = new ResizeObserver(
        debounce((entries) => {
          setCurrentWidth(Math.round(entries[0].contentRect.width));
        }, 60)
      );
    }
    customPlayerRef.current && ((_a = resizer == null ? void 0 : resizer.observe) == null ? void 0 : _a.call(resizer, customPlayerRef == null ? void 0 : customPlayerRef.current));
  }, []);
  return /* @__PURE__ */ React.createElement("div", null, !showControls && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.customPlayer, {
        [styles.customPlayer_basic]: !hasDetails,
        [styles.customPlayer_small_fit]: resizeWidths.small >= currentWidth,
        [styles.customPlayer_mobile]: isMobile,
        [styles.customPlayer_with_image]: coverImage == null ? void 0 : coverImage.src
      }),
      ref: customPlayerRef
    },
    (coverImage == null ? void 0 : coverImage.src) && /* @__PURE__ */ React.createElement(
      AudioImage,
      {
        coverImage,
        getImageUrl: helpers == null ? void 0 : helpers.getImageUrl,
        isSmallImage: !hasDetails
      }
    ),
    /* @__PURE__ */ React.createElement("div", { className: styles.track_wrapper }, hasDetails && /* @__PURE__ */ React.createElement(AudioDetails, { authorName, title: name }), showMobileDownloadIcon && /* @__PURE__ */ React.createElement(DownloadIcon, { className: styles.audio_download_icon, onClick: onDownload }), /* @__PURE__ */ React.createElement("div", { className: styles.trackContainer }, /* @__PURE__ */ React.createElement(
      AudioActionIcons,
      {
        handlePlay,
        handlePause,
        isPlaying,
        disabled,
        isLoading,
        helpers
      }
    ), !isMobile && renderAudioDuration(), /* @__PURE__ */ React.createElement("div", { className: styles.track_sliders_wrapper }, /* @__PURE__ */ React.createElement(
      Slider,
      {
        theme,
        languageDir: "ltr",
        value: played,
        dataHook: "audioSlider",
        onChange: handleSeekChange,
        onChangeCommitted: handleSeekMouseUp,
        step: "any",
        min: 0,
        max: 1,
        thumbVisibility: SLIDER_THUMB_VISIBILITY.hover,
        trackSize: SLIDER_TRACK_SIZE.small,
        liveSiteWiring: true,
        ariaLabel: "audio Slider"
      }
    ), /* @__PURE__ */ React.createElement(
      SoundControl,
      {
        theme,
        volume,
        handleMute,
        muted: volume === 0,
        handleVolumeChange: setVolume
      }
    )), isMobile && renderAudioDuration(), !isMobile && /* @__PURE__ */ React.createElement("button", { className: styles.audio_contextMenu_wrapper, tabIndex: -1 }, /* @__PURE__ */ React.createElement(
      ContextMenu,
      {
        onClickOutside,
        contextMenuData,
        playBackMenuData,
        showContextMenu,
        showPlaybackMenu,
        onClick: handleContextMenuClick
      }
    ))))
  ), /* @__PURE__ */ React.createElement(
    ReactPlayer,
    {
      url: URL,
      ref: reactPlayerRef,
      playing: disabled ? false : isPlaying,
      playbackRate,
      onPause: handlePause,
      onPlay: handlePlay,
      width: reactPlayerSize,
      height: reactPlayerSize,
      controls: showControls,
      volume,
      onProgress: handleProgress,
      onDuration: handleDuration,
      "data-loaded": !isLoading,
      onEnded,
      config: {
        file: {
          forceAudio: true
        }
      }
    }
  ));
};

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
const AudioEmbedViewer = ({
  isMobile,
  componentData,
  settings,
  theme,
  helpers
}) => {
  const {
    audio: {
      src: { url }
    },
    html
  } = componentData;
  const htmlCompProps = {
    componentData: {
      html,
      srcType: "html",
      src: unescape(html),
      config: {
        link: { rel: "", url, target: "_blank" },
        height: "100%",
        width: "100%"
      }
    },
    settings,
    theme,
    isMobile
  };
  useEffect(() => {
    var _a;
    (_a = helpers == null ? void 0 : helpers.mediaPluginsDetails) == null ? void 0 : _a.call(helpers, {
      pluginId: AUDIO_TYPE$1,
      creator: void 0,
      title: void 0,
      track_duration: void 0,
      type: AUDIO_TYPES.spotify,
      url
    });
  }, []);
  return /* @__PURE__ */ React.createElement(HtmlComponent, __spreadValues$2({}, htmlCompProps));
};

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const AudioViewer = ({
  theme,
  isMobile,
  helpers,
  settings,
  disabled,
  componentData,
  isLoading,
  store,
  block
}) => {
  var _a;
  const classes = useMemo(() => mergeStyles({ styles, theme }), [theme]);
  const { audio = {}, authorName, name, coverImage, disableDownload } = componentData;
  const url = getAudioSrc(audio == null ? void 0 : audio.src, settings);
  const shouldEmbed = componentData.html;
  const saveDurationToData = (duration) => {
    store == null ? void 0 : store.set(
      "componentData",
      __spreadProps(__spreadValues$1({}, componentData), { audio: __spreadProps(__spreadValues$1({}, componentData.audio), { duration }) }),
      block == null ? void 0 : block.getKey()
    );
  };
  return /* @__PURE__ */ React.createElement("div", { className: classes.container, "data-hook": "audioViewer" }, !shouldEmbed ? /* @__PURE__ */ React.createElement(
    ReactPlayerWrapper,
    {
      theme,
      url,
      name,
      authorName,
      coverImage: { src: coverImage == null ? void 0 : coverImage.file_name },
      disableDownload,
      helpers,
      isMobile,
      showControls: !!((_a = audio == null ? void 0 : audio.src) == null ? void 0 : _a.url),
      disabled,
      isLoading,
      saveDurationToData,
      isDownloadDisabled: settings == null ? void 0 : settings.disableDownload
    }
  ) : /* @__PURE__ */ React.createElement(
    AudioEmbedViewer,
    {
      componentData,
      settings,
      theme,
      isMobile,
      helpers
    }
  ));
};

const typeMapper = () => ({
  [AUDIO_TYPE]: { component: AudioViewer }
});

const DEFAULTS = Object.freeze({
  config: {
    size: "content",
    alignment: "center"
  }
});

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginAudio = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: AUDIO_TYPE,
    typeMapper
    // nodeViewRenderers,
  };
};

export { typeMapper as audioTypeMapper, pluginAudio };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-audio/dist/es/styles.viewer.min.global.css'